module.exports = __webpack_public_path__ + "media/images/1-7d4c25c020d83fcf656c5f6bfe15c916.png";